const styles = theme => ({
  root: {
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: '80px',
    },
  },
  notSelectedContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '400px',
    padding: theme.spacing(4),
  },
  notSelectedTitle: {
    textAlign: 'center',
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1),
  },
  notSelectedSubTitle: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(6, 0),
  },
  detailBody: {
    margin: theme.spacing(0, 4),
  },
  name: {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1),
  },
  text: {
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
    marginBottom: theme.spacing(1) / 2,
  },
})

export default styles
